// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"201": "ec043b79","51": "d95af539",}[chunkId] + ".chunk.js"
}